import { api } from "./api";

interface IFileId {
	file_id: number;
	ContractName: string;
	sample: boolean;
	docSize: number;
	docType: string;
	old: boolean;
	corrupted: boolean;
	llm_type: string;
	total_pages: number;
	code: string;
	name: string;
	blob_url: string;
	fileId: string;
}
export interface IUploadContractResponse {
	fileIds: Array<IFileId>;
}

// This documentation from `Microsoft` explains how to get the entire document file currently opened on user's Word Application
// https://learn.microsoft.com/en-us/javascript/api/office/office.document?view=common-js-preview#office-office-document-getfileasync-member(1)
export async function uploadContract({ fileName }: { fileName: string }): Promise<IUploadContractResponse> {
	const getFile = (): Promise<Office.File> =>
		new Promise((resolve, reject) => {
			Office.context.document.getFileAsync(Office.FileType.Pdf, (result: Office.AsyncResult<Office.File>) => {
				if (result.status === Office.AsyncResultStatus.Succeeded) {
					resolve(result.value);
				} else {
					reject(new Error("Failed to get the open contract"));
				}
			});
		});

	const getSlice = (file: Office.File, index: number): Promise<Office.Slice> =>
		new Promise((resolve, reject) => {
			file.getSliceAsync(index, (result: Office.AsyncResult<Office.Slice>) => {
				if (result.status === Office.AsyncResultStatus.Succeeded) {
					resolve(result.value);
				} else {
					reject(new Error(`Failed to get slice ${index}`));
				}
			});
		});

	let file: Office.File | null = null;

	try {
		file = await getFile();

		const sliceCount = file.sliceCount;
		const slices: ArrayBuffer[] = new Array(sliceCount);

		for (let i = 0; i < sliceCount; i++) {
			const slice = await getSlice(file, i);
			slices[i] = new Uint8Array(slice.data).buffer;
		}

		const pdf = new Blob(slices, { type: "application/pdf" });

		const formData = new FormData();
		formData.append("document", pdf, fileName);
		const data: any = await api.post("/api/v1/contracts/upload-contracts", formData, {
			headers: {
				"Content-Type": "multipart/form",
			},
		});

		if (!data?.success) {
			throw new Error(data?.message ?? "Failed to upload the contract");
		}

		return data;
	} catch (err) {
		throw err;
	} finally {
		file.closeAsync();
	}
}
